<template>
    <div>
        <modal ref="modal">
            <span slot="title">
                {{ form.id ? 'Edit' : 'New '}} Template Chat
            </span>
            <input-text label="Name" v-model="form.name" :form="form" field="name"></input-text>

            <div class="form-group">
                <label>Location</label>
                <multiselect :options="locations" v-model="form.locations" track-by="id" label="name" :multiple="true"
                             :loading="loadingLocations"></multiselect>
            </div>

            <div class="form-group">
                <div class="d-flex justify-content-between">
                    <label>Template</label>
                    <select name="variables" id="variables" class="form-control-sm tw--mt-1"
                            title="Select a variable that will be replaced by the real value."
                            data-toggle="tooltip" @change="addVariable" v-model="variable">
                        <option value="" selected disabled>Add a variable</option>
                        <option value="contact_name">Contact Name</option>
                        <option value="company_name">Company Name</option>
                        <option value="location_name">Location Name</option>
                    </select>
                </div>

                <textarea class="form-control" v-model="form.text"
                          :class="{ 'is-invalid': hasError('text') }"></textarea>
                <span class="mb-2 invalid-feedback">{{ hasError('text') }}</span>
            </div>
            <div slot="footer">
                <button class="btn btn-light" @click="close">
                    Cancel
                </button>
                <button-loading class="btn btn-primary ml-1" type="button"
                                @click="save" :loading="form.submitting">
                    Save
                </button-loading>
            </div>
        </modal>
    </div>
</template>

<script>
    import Form from "../../utils/Form";

    export default {
        data: () => ({
            form            : new Form({}),
            variable        : '',
            locations       : [],
            loadingLocations: false
        }),

        created() {
            this.fetchLocations();
        },

        methods: {

            fetchLocations() {
                this.$http.get(this.$laroute.route('api.global-filters.location', {hide: 'campaigns'}))
                    .then(({data}) => {
                        this.locations        = data.data;
                        this.loadingLocations = false;
                    });
            },

            addVariable() {
                this.form.text = (this.form.text ? this.form.text : '') + `{{${this.variable}}}`;
                this.variable  = '';
            },

            open(item = {}) {
                this.form = new Form(item);
                this.$refs.modal.open();

                this.$nextTick(() => {
                    $('[data-toggle="tooltip"]').tooltip();
                });
            },

            hasError(value) {
                return this.form.errors.get(value);
            },

            close(reload) {
                if (reload) this.$emit('reload');
                this.$refs.modal.close();
            },

            save() {
                let method = 'post';
                let url    = this.$laroute.route('api.chat.template.store');

                if (this.form.id) {
                    method = 'put';
                    url    = this.$laroute.route('api.chat.template.update', {template: this.form.id});
                }

                this.form[method](url).then(() => this.close(true));
            },
        },
    }
</script>
